import '../../styles/content/readyToGoContent.css'
import { useTranslation } from 'react-i18next'
import ContentCard, { ContentCardTooltips, ContentSkeleton, getContentKey, useRebuildTooltips } from './ToGo/ContentCard'

/** Shown in place of a list when a search matches nothing. */
export const NoSearchResults = ({ term, onClear }) => {
    const { t } = useTranslation()
    return (
        <div className="w-full flex flex-col items-center justify-center gap-4 py-[40px] rtg-empty" role="status">
            <p className="text-[16px] text-darkenPurple font-semibold">{t('noSearchResults', { term })}</p>
            <button type="button" className="showMoreLessButton !mt-0" onClick={onClear}>
                {t('clearSearch')}
            </button>
        </div>
    )
}

/**
 * Search results for one content type as a single flat list. The browse view
 * groups by topic and repeats an item under each of its topics; results show
 * every match exactly once, with a count.
 */
const SearchResults = ({ items = [], type, term, onClick = () => {}, onClear = () => {}, openCurrentlyRunningPrograms = () => {}, loading = false }) => {
    const { t } = useTranslation()
    useRebuildTooltips(items)

    return (
        <div className="type-home-container">
            {loading && <ContentSkeleton sections={1} />}
            {!loading && items.length === 0 && <NoSearchResults term={term} onClear={onClear} />}
            {!loading && items.length > 0 && (
                <div className="single-type-section">
                    <p className="single-type-section-title !mx-0 text-darkenPurple text-left" role="status">
                        {t('rtgSearchResults', { count: items.length, term })}
                    </p>
                    <div className="single-type-section-items">
                        {items.map((item, index) => (
                            <ContentCard
                                key={getContentKey(item, index)}
                                item={item}
                                index={index}
                                className="bg-[#F8F8FB] hover:bg-[#ECEBF8]"
                                iconFill="#413F5E"
                                onSelect={(selected) => onClick(selected, type)}
                                onOpenRunning={openCurrentlyRunningPrograms}
                                t={t}
                            />
                        ))}
                    </div>
                </div>
            )}
            <ContentCardTooltips />
        </div>
    )
}

export default SearchResults
